import MenuItem from "../Menu/MenuItem";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIsOpenSidebar, useIsOpenSidebarAction } from "../../context/toggleSidebarContext";
import { useEffect, useState } from "react";
import data from "../../mockData/menu.json";
import Restricted from "../../context/Restricted";
import { logout } from "../../services";
import { activeLink } from "../../utils/activeLink";
import { useAuth } from "../../context/AuthContext";

export default function Sidebar({ auth, layout }) {

    const [selectedParent, setSelectedParent] = useState(null);
    const { pages } = data;
    const setIsOpenSidebar = useIsOpenSidebarAction();
    const isOpenSidebar = useIsOpenSidebar();
    const route = useLocation()
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleHoverSidebar = () => {

        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: true })
        }
    }

    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const { isSuccess } = await logout();
            if (isSuccess) {
                const html = document.querySelector('html');

                html.className = '';

                navigate('/login')
            }
            setIsLoading(false)
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setSelectedParent(route.pathname.split("/")[1]);
    }, [route.pathname])

    const handleBlurSidebar = () => {
        if (isOpenSidebar.collapsed) {
            setIsOpenSidebar({ ...isOpenSidebar, hovered: false })
        }
    }

    useEffect(() => {
        if (isOpenSidebar.collapsed) {
            if (isOpenSidebar.expanded) {
                setIsOpenSidebar({ ...isOpenSidebar, expanded: false })
            }
        }
    }, [route.pathname])

    const onClickEitaa = () => {
        window.location.href = "https://eitaa.com/joinchat/2838365449C8e7b477668";
    }
    return (
        <aside
            id="layout-menu"
            className="layout-menu menu-vertical menu bg-menu-theme d-flex flex-column vh-100"
            onMouseEnter={handleHoverSidebar}
            onMouseLeave={handleBlurSidebar}
        >
            {/* HEADER */}
            <div className="row">
                <div className="col-12">
                    <div className="app-brand demo">
                        <button className="layout-menu-toggle bg-transparent border-0 menu-link text-large ms-auto">
                            <i
                                className="bx menu-toggle-icon d-none d-xl-block fs-4 align-middle"
                                onClick={() =>
                                    setIsOpenSidebar({
                                        ...isOpenSidebar,
                                        collapsed: !isOpenSidebar.collapsed,
                                    })
                                }
                            />
                            <i
                                className="bx bx-x d-block d-xl-none bx-sm align-middle"
                                onClick={() =>
                                    setIsOpenSidebar({ ...isOpenSidebar, expanded: false })
                                }
                            />
                        </button>
                    </div>
                </div>
            </div>

            {/* MENU (GROWS & SCROLLS) */}
            <div className="row flex-grow-1 overflow-auto">
                <div className="col-12">
                    <ul className="menu-inner py-1">
                        {pages &&
                            pages.length > 0 &&
                            pages
                                .filter(
                                    (x) =>
                                        x.layout === "public" ||
                                        (x.layout === layout && x.isAuth === auth !== null)
                                )
                                .map((item) => (
                                    <Restricted to={item?.permission || ""} key={item.id}>
                                        <MenuItem
                                            item={item}
                                            onClick={setSelectedParent}
                                            selectedParent={selectedParent}
                                        />
                                    </Restricted>
                                ))}

                        {auth != null && (
                            <li className="menu-item menu-item-animating">
                                <button
                                    className="menu-link w-100 border-0"
                                    onClick={handleLogout}
                                >
                                    <i className="menu-icon tf-icons bx bx-log-out" />
                                    <div>خروج</div>
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            {/* FOOTER (BOTTOM) */}
            <div className="row mt-auto text-center">
                <div className="col-12">
                    <p className="font-11 mb-1">شبکه های اجتماعی</p>

                    <img onClick={onClickEitaa}
                        src="/images/eita.png"
                        alt="Eitaa"
                        className="img-fluid mb-2"
                        style={{ maxHeight: 28 }}
                    />

                    <p className="font-11 mb-3">
                        App Version: {process.env.REACT_APP_VERSION}
                    </p>
                </div>
            </div>

        </aside>

    )
}